/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Local_PathInputs */

const en_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Path`)
};

const fr_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemin local`)
};

const de_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokaler Pfad`)
};

const it_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percorso locale`)
};

const ru_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Локальный путь`)
};

const es_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta local`)
};

const zh_cn2_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地路径`)
};

const ja_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルパス`)
};

const hi_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय पथ`)
};

const pt_pt2_local_path = /** @type {(inputs: Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminho local`)
};

/**
* | output |
* | --- |
* | "Local Path" |
*
* @param {Local_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const local_path = /** @type {((inputs?: Local_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_local_path(inputs)
	if (locale === "de") return de_local_path(inputs)
	if (locale === "it") return it_local_path(inputs)
	if (locale === "ru") return ru_local_path(inputs)
	if (locale === "es") return es_local_path(inputs)
	if (locale === "zh-CN") return zh_cn2_local_path(inputs)
	if (locale === "ja") return ja_local_path(inputs)
	if (locale === "hi") return hi_local_path(inputs)
	if (locale === "pt-PT") return pt_pt2_local_path(inputs)
	return en_local_path(inputs)
});